module.exports = __webpack_public_path__ + "static/media/u.9eba78ad.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/u.mp3
// module id = 110
// module chunks = 0